import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M8.08926 4.42259C8.41469 4.09715 8.41469 3.56951 8.08926 3.24408C7.76382 2.91864 7.23618 2.91864 6.91074 3.24408L2.74408 7.41074C2.41864 7.73618 2.41864 8.26382 2.74408 8.58926C3.06951 8.91469 3.59715 8.91469 3.92259 8.58926L8.08926 4.42259Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M11.9107 4.42259C11.5853 4.09715 11.5853 3.56951 11.9107 3.24408C12.2362 2.91864 12.7638 2.91864 13.0893 3.24408L17.2559 7.41074C17.5814 7.73618 17.5814 8.26382 17.2559 8.58926C16.9305 8.91469 16.4028 8.91469 16.0774 8.58926L11.9107 4.42259Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M6.66667 10.4325C7.1269 10.4325 7.5 10.8056 7.5 11.2658V13.7658C7.5 14.226 7.1269 14.5991 6.66667 14.5991C6.20643 14.5991 5.83333 14.226 5.83333 13.7658V11.2658C5.83333 10.8056 6.20643 10.4325 6.66667 10.4325Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M13.3333 10.4325C13.7936 10.4325 14.1667 10.8056 14.1667 11.2658V13.7658C14.1667 14.226 13.7936 14.5991 13.3333 14.5991C12.8731 14.5991 12.5 14.226 12.5 13.7658V11.2658C12.5 10.8056 12.8731 10.4325 13.3333 10.4325Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  d: "M10 10.4325C10.4602 10.4325 10.8333 10.8056 10.8333 11.2658V13.7658C10.8333 14.226 10.4602 14.5991 10 14.5991C9.53976 14.5991 9.16667 14.226 9.16667 13.7658V11.2658C9.16667 10.8056 9.53976 10.4325 10 10.4325Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.33333 7.16667C2.8731 7.16667 2.5 7.53976 2.5 8V15.5C2.5 16.8807 3.61929 18 5 18H15C16.3807 18 17.5 16.8807 17.5 15.5V8C17.5 7.53976 17.1269 7.16667 16.6667 7.16667H3.33333ZM4.16667 15.5V8.83333H15.8333V15.5C15.8333 15.9602 15.4602 16.3333 15 16.3333H5C4.53976 16.3333 4.16667 15.9602 4.16667 15.5Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7
  ]))
}